import { FC, useRef, useState, useEffect, Fragment } from 'react'
import clsx from 'clsx'

import TwoColumnsCards from './two-column-cards/two-column-cards'
import Loader from 'components/parts/loader/loader'
import LinkWrap from 'containers/link-wrap/link-wrap'

import { IFilterCards, IFilterCard } from 'constants/types/search.types'

import styles from './filter-cards.module.scss'

const OneColumnsCards = ({
  cards,
  cardModificator,
}: {
  cards: IFilterCard[]
  cardModificator?: string
}) => (
  <>
    {cards.map((card) => (
      <Fragment key={card.key || card.url}>
        <LinkWrap
          className={clsx(styles.cardWrap, cardModificator)}
          href={card.url}
          prefetch={false}
        >
          {card.item}
        </LinkWrap>

        {card.courseNmo}
      </Fragment>
    ))}
  </>
)

const FilterCards: FC<IFilterCards> = ({
  cards,
  isLoading,
  oneColumn,
  component,
  cardModificator,
}: IFilterCards) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isNoCardsMessage, setNoCardsActive] = useState(false)

  useEffect(() => {
    //таймаут появления сообщения, если ничего не найдено в при первом переключении тоггла
    setNoCardsActive(false)
    let timeout: ReturnType<typeof setTimeout>
    if (!cards?.length) {
      timeout = setTimeout(() => setNoCardsActive(true), 500)
    }
    return () => clearTimeout(timeout)
  }, [cards])

  const currentCards = oneColumn ? (
    <OneColumnsCards cards={cards} cardModificator={cardModificator} />
  ) : (
    <TwoColumnsCards cards={cards} />
  )

  return (
    <div className={styles.cards}>
      <main className={styles.content} ref={containerRef}>
        {cards && Boolean(cards?.length)
          ? currentCards
          : isNoCardsMessage &&
            !isLoading &&
            (component || <p className={styles.noCards}>По вашему запросу ничего не найдено</p>)}
      </main>
      {isLoading && <Loader />}
    </div>
  )
}

export default FilterCards
